// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"49f289cc","389":"bb97b068","453":"af205ec6","732":"15969559","977":"f73fe8b0"}[chunkId] + ".chunk.js";
};